import { AnyAction } from "redux";
import {
  REQUEST_FETCH_WARDS,
  REQUEST_FETCH_WARDS_ERROR,
  REQUEST_FETCH_WARDS_SUCCESS,
} from "redux/actions/general/wards";

const defaultState = {
  data: [],
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_WARDS:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_FETCH_WARDS_SUCCESS:
      return {
        data: action.wards,
        error: null,
        loading: false,
      };
    case REQUEST_FETCH_WARDS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
